module.exports = __webpack_public_path__ + "media/images/game_icon/en/AB1527-bde29d1bc540bb22c28951d80caab23b.png";